// extracted by mini-css-extract-plugin
module.exports = {"table":"StorylineTable_table__aQdxd"};